<dx-load-indicator *ngIf="!status || !intervention; else widgets" height="40" width="40"></dx-load-indicator>
<ng-template #widgets>
  <div style="padding-left: 25px;" class="flex flex-wrap">
    <!--<lib-pulse-dot style="position: absolute; top:50%; margin-top: -8px; left: 10px;"
                   [hint]="intervention.stateText"
                   [color]="intervention.stateColor"></lib-pulse-dot>-->
    <div class="widget">
      <span class="value">{{tractor.tracker.speed | number:'2.0-0'}} <span class="unit">Km/h</span></span>
      <span class="title">Vitesse</span>
    </div>
    <div class="widget">
      <span class="value">{{intervention.workingAreaHa | number:'1.2-2'}} <span class="unit">Ha</span></span>
      <span class="title">Superficie</span>
    </div>
    <div class="widget">
      <span class="value">{{intervention.workingAreaRate  | number:'1.2-2'}} <span class="unit">Ha/h</span></span>
      <span class="title">Débit</span>
    </div>
    <div class="widget">
      <span class="value">{{intervention.durationStr}} <span class="unit">h</span></span>
      <span class="title">Durée</span>
    </div>
    <div class="details-list">
      <div>Tracteur</div>
      <div>{{tractor.name}}</div>
      <div>Outil</div>
      <div>{{status.trailer_name}} {{status.trailer_operation_name}}</div>
      <div>Parcelle</div>
      <div>{{status.field_name}}</div> 
    </div>
  </div>
</ng-template>

<dx-button (onClick)="close()" stylingMode="outlined" icon="close"></dx-button>
